import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { PwaAppInstallerService } from './pwa-app-installer.service';

@Component({
  selector: 'pd-install-pwa',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule],
  template: `
    <button
      *ngIf="pwa.showCustomButton()"
      (click)="pwa.promptInstallPwa()"
      mat-raised-button
      color="accent"
      type="button"
      class="js-button"
    >
      Install App
    </button>

    <button
      *ngIf="pwa.showIosCustomButton"
      (click)="pwa.promptInstallPwaOnIos()"
      mat-raised-button
      color="accent"
      type="button"
      class="js-ios-button"
    >
      Install App
    </button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallPwaComponent {
  pwa = inject(PwaAppInstallerService);

  isVisible = computed(() => {
    return this.pwa.showCustomButton() || this.pwa.showIosCustomButton;
  });
}
